enum ActivityControlBarStepType {
    None = "None",
    TrackedQuestionsStep = "TrackedQuestionsStep",
    QuestionSubStep = "QuestionSubStep",
    RelatedQuestionSubStep = "RelatedQuestionSubStep"
}

export default ActivityControlBarStepType;